import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";

export default function VanPurchaseInfo({data, handlers, setCurrentStep}) {

    return (
        <div className="van-purchase-info">

            <div className="row">

                {/* Did you purchase the van? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3"
                    labelText="Did you purchase the van?"
                    required={true}
                    controlName="vanPurchased"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.vanPurchased}
                    onChange={handlers.onControlChange}
                />

            </div>

            {/* vanPurchased */}

            {data.vanPurchased === 'Yes' && (

                <div className="row hidden-box">


                    {/* Purchase date */}

                    <ScrollableCustomDateTimePickerBlock
                        containerCssClass="col-12 py-3"
                        labelText="Purchase date"
                        required={data.vanPurchased === 'Yes'}
                        controlName="vanPurchaseDate"
                        value={data.vanPurchaseDate}
                        onChange={handlers.onControlChange}
                    />
                </div>

            )}


        </div>
    );

}